module.exports = __webpack_public_path__ + "public/img/sjj.a85d6e7f.png";